import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useAuth } from '../../../components/contexts/AuthContext';
import { registerSessionReset } from '../../../utils/sessionLifecycle';
import { createMediaTextStore } from '../viewmodels/mediaTextStore';
import { mediaTextEnabled } from '../models/mediaTextApi';

const Context = createContext(null);
export const useMediaTextStore = () => useContext(Context);
export function MediaTextProvider({ children }) {
  const { authState } = useAuth();
  const actor = authState?.isAuthenticated ? authState.id : null;
  const { store } = useMemo(() => ({ actor, store: createMediaTextStore() }), [actor]);
  useEffect(() => {
    store.activate();
    const unregister = registerSessionReset(() => store.dispose());
    return () => { unregister(); store.dispose(); };
  }, [store]);
  return <Context.Provider value={actor != null && mediaTextEnabled() ? store : null}>{children}</Context.Provider>;
}
